import { Component, HostListener, OnInit } from '@angular/core';
import { images } from './fixtures/imageGrid.data';
import { GridImage } from '@frk/eds-components';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Logger } from '@utils/logger';
import { WidenService } from '@services/widen.service';
import { AppStateService } from '@services/app-state.service';
import { LinkService } from '@services/link.service';
import { ViewModeService } from '@services/view-mode.service';
const logger = Logger.getLogger('ImageGrid');

@Component({
  selector: 'ft-image-grid',
  templateUrl: './image-grid.component.html',
  styleUrls: ['./image-grid.component.scss'],
})
export class ImageGridComponent
  extends AbstractBaseComponent
  implements OnInit {
  public images: GridImage[] = images;
  // imageGridLayout: boolean;
  public hasLink: boolean;
  // TODO: Parameters not covered in EDS yet. For future development.
  public isImageGridLayoutMobile = true;
  public isImageGridLayoutTablet = true;
  public isTitleBold = false;

  /**
   * Content boolean
   */
  public hasContent = false;
  /**
   * Decides if the image grid is marquee carousel
   */
  public showAsCarousel = false;
  /**
   * Amount of length that the user scroll for
   */
  private scrollAmount = 0;
  /**
   * Initial position where the user starts scrolling from
   */
  private dragStartX = 0;

  /**
   * Show Logos in color in carousel
   */
  public showLogoColorInCarousel = false;

  constructor(
    private appStateService: AppStateService,
    private widenService: WidenService,
    private linkService: LinkService,
    private viewModeService: ViewModeService
  ) {
    super();
    this.isEditMode = this.viewModeService.isEditMode();
  }

  ngOnInit(): void {
    this.hasContent = this.imageGridCompound?.length > 0;
    this.images = this.getImages();
    this.isTitleBold = this.getIsTitleBold();
    this.showAsCarousel = this.configureCarousel();
  }

  /**
   * Get Image Grid Compound array
   */
  get content(): any {
    if (this.document?.getData()) {
      return this.document?.getData();
    }
  }

  /**
   * Get Image Grid Compound array
   */
  get imageGridCompound(): any[] {
    if (this.document?.getData()?.imageGridCompound) {
      return this.document?.getData()?.imageGridCompound;
    }
    return [];
  }

  /**
   * Get imageGridLayout component parameter
   */
  get imageGridLayout(): string {
    const { ImageGrid } = this.component.getModels();

    // Below condition added if user select both the layout.
    if (ImageGrid?.imageGridLayout && ImageGrid?.imageGridLayout5) {
      return '5-columns';
    }

    if (ImageGrid?.imageGridLayout) {
      return '4-columns';
    }

    if (ImageGrid?.imageGridLayout5) {
      return '5-columns';
    }
  }

  /**
   * Get is title bold
   */
  getIsTitleBold(): boolean {
    return this.component.getModels()?.ImageGrid?.titleBold;
  }

  /**
   * Get Images from document
   */
  getImages(): GridImage[] {
    const imageGrid: any[] = this.imageGridCompound;
    if (imageGrid) {
      const gridImg: GridImage[] = [];

      imageGrid.forEach((img: any) => {
        let link;
        if (img.linkCompound?.linkCollection?.length > 0) {
          link = this.linkService.getCTALink(
            this.page,
            img.linkCompound.linkCollection[0],
            this.appStateService?.getHomePageUrl()
          );
          // TODO: Bug in EDS - if only one image has link, all in the grid have anchor tags. It needs to be fixed in EDS.
          if (link !== '') {
            this.hasLink = true;
          }
        }

        gridImg.push({
          src: this.widenService.getWidenAssetUrl(
            img.imageCompound?.widenAsset
          ),
          altText: img.imageCompound?.alt
            ? img.imageCompound?.alt
            : img.imageCompound?.title,
          link,
          target: img.linkCompound?.linkCollection[0]?.target,
          externalLink: img.linkCompound?.linkCollection[0]?.external,
          signInRequired: img.linkCompound?.linkCollection[0]?.signInLink,
        });
      });
      return gridImg;
    }
    logger.debug('Images are not set in document');
    return images;
  }

  /**
   * Sets showAsCarousel variable from BR response.
   * @returns boolean, if the image grid should be carousel.
   */
  private configureCarousel(): boolean {
    const { ImageGrid } = this.component.getModels();
    this.showLogoColorInCarousel = ImageGrid?.logoColor;
    return ImageGrid?.imageCarousel ? true : false;
  }

  // Preventing accidental clicks from just the EDS side is not enough, adding the same on core-sites
  // to prevent this from happening.
  /**
   * Captures the initial mouse/touch horizontal X-axis position.
   * @param event Mouse/Touch event fired once someone clicks or touches the component
   */
  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent | TouchEvent): void {
    this.dragStartX =
      event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    this.scrollAmount = 0;
  }

  /**
   * This prevents accidental clicks on the logo-image link, it fires only when scroll isn't involved
   * @param event Click event fired on mouse/touch click.
   */
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent | TouchEvent): void {
    // Prevents accidental clicks if the user has scrolled
    if (Math.abs(this.scrollAmount)) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.scrollAmount = 0;
  }

  /**
   * Calculates the amount scrolled by the user.
   * @param event Tracks the length of scroll
   */
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent | TouchEvent): void {
    const clientX =
      event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    const actualScrollAmount = clientX - this.dragStartX;
    this.scrollAmount = actualScrollAmount;
  }
}
